import type { PostOfficeUserInteractionHandlers } from '@atlassian/post-office-analytics/types';

import { ChecklistItemId, type ChecklistItemCompletedFromTraits } from './types';

export const recordChecklistItemAction = (
	onCtaActioned: PostOfficeUserInteractionHandlers['onCtaActioned'],
	itemId: ChecklistItemId,
	itemStates: ChecklistItemCompletedFromTraits,
	totalSteps: number,
): void => {
	const additionalMetadata = {
		itemId,
		numberOfStepsCompleted: Object.values(itemStates).filter(Boolean).length,
		totalSteps,
	};

	switch (itemId) {
		case ChecklistItemId.writeStatusUpdate:
			onCtaActioned({
				interactionIdentifier: 'checklist-item-writeStatusUpdate',
				additionalMetadata,
			});
			break;
		case ChecklistItemId.connectWorkTools:
			onCtaActioned({
				interactionIdentifier: 'checklist-item-connectWorkTools',
				additionalMetadata,
			});
			break;
		case ChecklistItemId.askRovoFind:
			onCtaActioned({
				interactionIdentifier: 'checklist-item-askRovoFind',
				additionalMetadata,
			});
			break;
		case ChecklistItemId.deepResearch:
			onCtaActioned({
				interactionIdentifier: 'checklist-item-deepResearch',
				additionalMetadata,
			});
			break;
		case ChecklistItemId.promptGallery:
			onCtaActioned({
				interactionIdentifier: 'checklist-item-promptGallery',
				additionalMetadata,
			});
			break;
		case ChecklistItemId.browseAgents:
			onCtaActioned({
				interactionIdentifier: 'checklist-item-browseAgents',
				additionalMetadata,
			});
			break;
		case ChecklistItemId.automateWork:
			onCtaActioned({
				interactionIdentifier: 'checklist-item-automateWork',
				additionalMetadata,
			});
			break;
		case ChecklistItemId.installExtension:
			onCtaActioned({
				interactionIdentifier: 'checklist-item-installExtension',
				additionalMetadata,
			});
			break;
	}
};

export const recordChecklistCompletion = (
	onAcknowledged: PostOfficeUserInteractionHandlers['onAcknowledged'],
): void => {
	onAcknowledged({
		interactionIdentifier: 'checklist-all-completed',
	});
};
